export default __webpack_public_path__ + "static/media/portfolio-109.d61432c9.jpg";